import { Invite } from './../../../@core/interfaces/portal/provider';
import { Component, Input, Output, EventEmitter, AfterViewInit, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EMAIL_PATTERN } from '../../../@auth/components';
import { ProviderData } from '../../../@core/interfaces/portal/provider';
import { takeUntil } from 'rxjs-compat/operator/takeUntil';
import { Subject } from 'rxjs';
import { NbToastrService } from '@nebular/theme';

@Component({
    selector: 'Invite',
    templateUrl: './invite.component.html',
    styleUrls: ['./invite.component.scss'],
})
export class InviteComponent implements  OnInit, AfterViewInit {

    showModal = false;
    quoteForm: FormGroup;
    invite: Invite;
    protected readonly unsubscribe$ = new Subject<void>();
    
    constructor(
      private location: Location, 
      private fb: FormBuilder, 
      private toastrService: NbToastrService,
      private providerService: ProviderData) { }

    ngAfterViewInit() {
      this.showModal = true;
    }
    
    ngOnInit(): void {
      this.initOrderForm();
    }

    get group() {return this.quoteForm.get('group'); }
    get email() { return this.quoteForm.get('email'); }

    initOrderForm() {
        this.quoteForm = this.fb.group({
          group: this.fb.control('', [Validators.required, Validators.minLength(4), Validators.maxLength(10)]),
          email: this.fb.control('', [
            Validators.required,
            Validators.pattern(EMAIL_PATTERN),
          ]),
        });
    }

    onClose() {
      this.showModal = false;
      //Allow fade out animation to play before navigating back
      setTimeout(
        () => this.location.back(),
        100
      );
    }

    onSend() {

      this.invite = this.quoteForm.value;
      const observable = this.providerService.inviteProvider(this.invite);

      observable.subscribe(response => {
        if (response.status == '200') {
          this.toastrService.success(response.mensagem, `Convite enviado ao fornecedor com sucesso!`);
          setTimeout(() => this.location.back(), 100);
        } else {
          this.toastrService.danger(response.mensagem, 'Erro ao enviar convite ao fornecedor, tente novamente.');
        }
      });
      }

    onDialogClick(event: UIEvent) {
      // Capture click on dialog and prevent it from bubbling to the modal background.
      event.stopPropagation();
      event.cancelBubble = true;
    }
}